import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.name";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { EventBus } from '../../../services/eventbus.js';
import { themesMixin } from '../../../utils/themes';
import get from 'lodash/get';
import remove from 'lodash/remove';
export default {
  name: 'ViewNiotaClassicDevicesDeviceDetails',
  mixins: [themesMixin],
  data: function data() {
    return {
      deviceId: null,
      tabItem: 'details',
      datasourceType: null,
      devicePacketsCount: 0,
      deviceData: null,
      viewPath: null,
      viewPathTab: null,
      formDialog: false,
      csvExportDialog: false,
      applications: [],
      deviceTypes: [],
      allRelevantKeys: [],
      allRelevantKeysRaw: [],
      maxPackets: 12,
      packetsLoading: false,
      devicePackets: [],
      packetIndex: 0,
      keysDatasets: {},
      parsedPackets: {},
      parsedPacketsSize: 0,
      packetsByTimestamps: {},
      isLoading: false,
      qrScanner: false,
      from: '0',
      isLoadingGraph: true,
      showLoadMorePackets: false,
      visualizeGraphsToggle: false,
      dynamicGraph: {},
      parsedPacketsOptions: {},
      application: null,
      connection: null,
      lclObjectStr: null,
      btnDisabled: false,
      parsedPacketsLimit: 10,
      loadMoreParsedPackets: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    headerBG: function headerBG() {
      return './img/dtwin-factory1.png';
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    n1Protocol: function n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host: function n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    },
    isIotHubManager: function isIotHubManager() {
      return this.permissions['IotHub.manage'];
    }
  }),
  watch: {
    $route: function $route() {
      this.initData();
    }
  },
  mounted: function mounted() {
    this.initData();
  },
  destroyed: function destroyed() {
    this.teardownWebSocket();
  },
  methods: {
    breadCrumbsPath: function breadCrumbsPath() {
      if (get(this, 'application.title') && get(this, 'application.account.name')) {
        return [this.permissions['all.manage'] ? {
          text: this.application.account.name,
          to: "/account-mgmt/".concat(this.application.account.id)
        } : this.application.account.name, {
          text: this.application.title,
          to: "/niota-classic/applications/".concat(this.application.id, "/details")
        }, this.deviceData.title];
      }

      return [];
    },
    initData: function initData() {
      this.deviceId = this.$route.params.deviceId;
      this.fetchDeviceDetails();
    },
    getDeviceImageUrl: function getDeviceImageUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }

      return "".concat(process.env.VUE_APP_N1_API_PROTOCOL, "://").concat(process.env.VUE_APP_N1_API_HOST).concat(image);
    },
    fetchDeviceDetails: function fetchDeviceDetails() {
      var _this = this;

      NiotaClassicApiService.deviceGetDetails(this.deviceId).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.deviceData = res.data.device;

                  if (!_this.deviceData.id) {
                    _context.next = 10;
                    break;
                  }

                  if (get(_this.deviceData, 'originator.datasource.type')) {
                    _this.setDatasourceType(get(_this.deviceData, 'originator.datasource.type'));
                  }

                  if (!_this.devicePackets.length) {
                    _this.fetchDevicePackets();
                  }

                  if (!_this.deviceTypes.length) {
                    _this.deviceTypeFetchPlain();
                  }

                  if (!_this.applications.length) {
                    _this.applicationsFetchPlain();
                  }

                  if (_this.application) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 9;
                  return _this.getApplication();

                case 9:
                  EventBus.$emit('update-breadcrumbs');

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this.deviceData = null;

        _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.notFound'), 'error');

        console.error(error);
      });
    },
    fetchDevicePackets: function fetchDevicePackets() {
      var _this2 = this;

      this.packetsLoading = true;
      NiotaClassicApiService.deviceFetchPackets(this.deviceId, this.from, this.devicePackets.length).then(function (res) {
        if (res.data.packets.length) {
          _this2.setDevicePackets(res.data.packets);

          _this2.maxPackets = res.data.packets.length;
          _this2.devicePacketsCount = _this2.maxPackets;
        }

        if (!res.data.packets.length && _this2.devicePackets.length > 0) {
          _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.noMorePackets'), 'error');

          _this2.btnDisabled = true;
        }

        if (!res.data.packets.length && _this2.from !== '0') {
          _this2.from = '0';

          _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.noPacketsInThisPeriod'), 'error');

          _this2.fetchDevicePackets();
        }
      }).catch(function (error) {
        _this2.devicePackets = []; // this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.devicePacketsNotFound'), 'error');

        console.error(error);
      }).finally(function () {
        return _this2.packetsLoading = false;
      });
    },
    deviceFetchParsedPackets: function deviceFetchParsedPackets() {
      var _this3 = this;

      this.isLoading = true;
      this.isLoadingGraph = true;
      NiotaClassicApiService.deviceFetchParsedPackets(this.deviceData.id, this.parsedPacketsOptions).then(function (res) {
        _this3.setDeviceParsedPackets(res.data);
      }).catch(function (error) {
        // this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorLoadingParsedPackets'), 'error');
        console.error(error);
      }).finally(function () {
        _this3.isLoading = false;
        _this3.isLoadingGraph = false;
      });
    },
    getApplication: function getApplication() {
      var _this4 = this;

      return NiotaClassicApiService.applicationGet(this.deviceData.applicationId).then(function (res) {
        _this4.application = res.data.application;

        _this4.teardownWebSocket();

        _this4.setupN1WebSocket(_this4.deviceData.id, _this4.application.account.data.realTimeApiKey);
      }).catch(function (res) {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.Devices.snacks.applicationNotFound'), 'error');

        console.error(res);
      });
    },
    loadParsedPackets: function loadParsedPackets(options) {
      this.parsedPacketsOptions = options;
      this.deviceFetchParsedPackets();
    },
    loadParsedPacketsForVisualization: function loadParsedPacketsForVisualization(limit) {
      this.parsedPacketsLimit = limit;
      this.loadMoreParsedPackets = true;

      if (this.parsedPacketsOptions.limit) {
        this.parsedPacketsOptions.limit = limit;
      } else {
        this.parsedPacketsOptions = {
          limit: limit
        };
      }

      this.deviceFetchParsedPackets();
    },
    deviceTypeFetchPlain: function deviceTypeFetchPlain() {
      var _this5 = this;

      NiotaClassicApiService.deviceTypeFetchPlain().then(function (res) {
        _this5.deviceTypes = res.data.devicetypes;
      }).catch(function (error) {
        _this5.deviceTypes = [];

        _this5.$snack(_this5.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');

        console.error(error);
      });
    },
    applicationsFetchPlain: function applicationsFetchPlain() {
      var _this6 = this;

      NiotaClassicApiService.applicationsFetchPlain().then(function (res) {
        _this6.applications = res.data.applications;
      }).catch(function (error) {
        _this6.applications = [];

        _this6.$snack(_this6.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');

        console.error(error);
      });
    },
    setDatasourceType: function setDatasourceType(datasourceType) {
      var type = this.setJoinViewValues(datasourceType.toUpperCase());
      this.datasourceType = type;
    },
    setJoinViewValues: function setJoinViewValues(type) {
      type === 'FIREFLY' ? type = 'FIREFLY_MQTT' : type;
      type === 'TEMETRA' ? type = 'UDP' : type;
      type === 'DISCOVERGY' ? type = 'UDP' : type;
      return type;
    },
    viewAllDevices: function viewAllDevices() {
      this.$router.push({
        path: '/niota-classic/devices'
      });
    },
    refresh: function refresh() {
      this.fetchDeviceDetails();
    },
    setDevicePackets: function setDevicePackets(packets) {
      var _this7 = this;

      this.devicePackets = [].concat(_toConsumableArray(this.devicePackets), _toConsumableArray(packets));
      packets.forEach(function (packet) {
        packet.uid = _this7.packetIndex;
        _this7.packetIndex++;
      }); // change here for parsed packets

      if (packets.length && !this.parsedPackets) {
        this.allRelevantKeys = [];
        this.keysDatasets = this.getKeysDatasets(this.devicePackets, this.allRelevantKeys, false);
        this.allRelevantKeys = this.keysDatasets.allRelevantKeys;
      }

      if (!this.application && !this.connection) {
        this.getApplication();
      }
    },
    getKeysDatasets: function getKeysDatasets(allPackets, allRelevantKeys, advance) {
      var datasets = []; //need to be returned

      var allRelevantKeysRaw = [];

      if (allPackets[0] && allPackets[0].source_data && allPackets[0].source_data.parsed) {
        var parsed = allPackets[0].source_data.parsed;
        var keys = Object.keys(parsed);
        keys.forEach(function (key) {
          if (typeof parsed[key] === 'number') {
            allRelevantKeysRaw.push(key);
            allRelevantKeys.push(advance ? "".concat(key.toUpperCase(), "*") : key.toUpperCase());
          }
        });
      }

      this.sortCaseInsensitive(allRelevantKeys);
      this.sortCaseInsensitive(allRelevantKeysRaw);
      allRelevantKeys.forEach(function (relevantKey, key) {
        var currentKeyArray = [];
        var keyName = advance ? "".concat(allRelevantKeysRaw[key], "*") : allRelevantKeysRaw[key];
        allPackets.forEach(function (packet) {
          currentKeyArray.push(packet.source_data.parsed[keyName]);
        });
        datasets.push([{
          label: keyName,
          data: currentKeyArray
        }]);
      });
      return {
        allRelevantKeys: allRelevantKeys,
        datasets: datasets
      };
    },
    sortCaseInsensitive: function sortCaseInsensitive(array) {
      array.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    },
    getParsedPacketsSize: function getParsedPacketsSize(parsedPackets) {
      var biggestPacketLength = 0;
      Object.keys(parsedPackets).forEach(function (key) {
        if (parsedPackets[key].length > biggestPacketLength) {
          biggestPacketLength = parsedPackets[key].length;
        }
      });
      return biggestPacketLength;
    },
    setDeviceParsedPackets: function setDeviceParsedPackets(packets) {
      this.parsedPackets = packets.data;

      if (packets.timestampsData) {
        this.packetsByTimestamps = packets.timestampsData;
      }

      this.parsedPacketsSize = this.getParsedPacketsSize(this.parsedPackets);

      if (this.loadMoreParsedPackets && this.parsedPacketsLimit > this.parsedPacketsSize) {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.noMorePackets'), 'error');
      }

      var graphInput = this.graphInputs(this.parsedPackets, this.parsedPacketsSize, true); // change here for parsed packets

      if (this.parsedPacketsSize && !this.parsedPackets) {
        this.keysDatasets = this.getKeysDatasetsParsed(this.parsedPackets, this.allRelevantKeys, false);
        this.allRelevantKeys = this.keysDatasets.allRelevantKeys;
      }

      this.visualizeParsedPacketsGenerator(graphInput);
    },
    getKeysDatasetsParsed: function getKeysDatasetsParsed(parsedPackets, allRelevantKeys, advance) {
      var _this8 = this;

      var datasets = [];
      var allRelevantKeysRaw = [];
      Object.keys(parsedPackets).forEach(function (key) {
        if (parsedPackets[key].length) {
          allRelevantKeysRaw.push(key);
          allRelevantKeys.push(advance ? "".concat(key.toUpperCase(), "*") : key.toUpperCase());
        }
      });
      this.sortCaseInsensitive(allRelevantKeys);
      this.sortCaseInsensitive(allRelevantKeysRaw);
      this.allRelevantKeysRaw = allRelevantKeysRaw;
      allRelevantKeysRaw.forEach(function (key) {
        var typeName = get(parsedPackets[key][0], 'value_type_name', '').toLowerCase();

        if (typeName && typeName !== 'string') {
          var keyName = advance ? "".concat(key, "*") : key;
          var currentKeyArray = [];
          parsedPackets[key].forEach(function (packet) {
            currentKeyArray.push(packet.value);
          });
          datasets.push([{
            label: "".concat(keyName, "(").concat(typeName || _this8.$i18n_t('Common.notAvailable'), ")"),
            data: currentKeyArray
          }]);
        } else {
          remove(allRelevantKeys, function (element) {
            return element.toLowerCase() === key;
          });
        }
      });
      return {
        allRelevantKeys: allRelevantKeys,
        datasets: datasets
      };
    },
    graphInputs: function graphInputs(packets, packetsLength) {
      var parsed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var xAxisArray = this.axisGenerator(packetsLength);
      this.allRelevantKeys = [];
      var keysDatasets = parsed ? this.getKeysDatasetsParsed(packets, this.allRelevantKeys, false) : this.getKeysDatasets(packets, this.allRelevantKeys, false);
      this.allRelevantKeys = keysDatasets.allRelevantKeys;
      var keys = this.allRelevantKeys;
      var datasets = keysDatasets.datasets;
      return {
        keys: keys,
        datasets: datasets,
        xAxisArray: xAxisArray
      };
    },
    //generates the x axis for the graphs depending on the packets length
    axisGenerator: function axisGenerator(packetsLength) {
      var generatedArray = [];

      for (var i = 0; i < packetsLength; i++) {
        generatedArray.push(i + 1);
      }

      return generatedArray;
    },
    loadMorePackets: function loadMorePackets() {
      var lastPacketIndex = this.devicePackets.length - 1;
      var lastPacket = this.devicePackets[lastPacketIndex];

      if (lastPacket !== undefined) {
        this.fetchDevicePackets();
      }
    },
    fetchDevicePacketsByDate: function fetchDevicePacketsByDate(date) {
      this.devicePackets = [];
      this.from = date;
      this.fetchDevicePackets();
    },
    visualizeParsedPacketsGenerator: function visualizeParsedPacketsGenerator(graphInput) {
      this.dynamicGraphs(graphInput.keys, graphInput.datasets, graphInput.xAxisArray);
      this.showLoadMorePackets = true;
      this.visualizeGraphsToggle = true;
    },
    dynamicGraphs: function dynamicGraphs(keys, datasets, axisArray) {
      var _this9 = this;

      keys.forEach(function (key, index) {
        if (datasets[index]) {
          _this9.updateGraph(key, axisArray, datasets[index]);
        }
      });
    },
    updateGraph: function updateGraph(key, labels, datasets) {
      this.dynamicGraph[key] = {
        data: datasets[0].data,
        label: datasets[0].label,
        color: this.vuetifyColorHex(),
        dataLabels: labels
      };
    },
    setupN1WebSocket: function setupN1WebSocket(id, key) {
      this.lclObjectStr = 'Establishing connection\n';
      this.connection = new WebSocket("ws".concat(this.n1Protocol === 'https' ? 's' : '', "://").concat(this.n1Host, "/api/x/websocket/devices/").concat(id, "?auth=").concat(key));
      var instance = this;

      this.connection.onmessage = function (event) {
        instance.lclObjectStr += "Data-Packet START:\n".concat(event.data, "\nData-Packet END\n"); // console.log('WS-Data:', { data: event.data });
        // instance.websocketPackets.unshift(JSON.parse(event.data));

        instance.setPacket(JSON.parse(event.data));
      };

      this.connection.onopen = function () {
        // console.log('WS: Connected');
        instance.lclObjectStr += 'Successfully connected to the websocket server\nWaiting for data...\n';
        instance.wsConnected = true;
      };

      this.connection.onerror = function (error) {
        instance.lclObjectStr += "An error occurred: ".concat(error, "\n");
      };

      this.connection.onclose = function () {
        instance.lclObjectStr += 'Disconnected from WebSocket Server\n';
      };
    },
    teardownWebSocket: function teardownWebSocket() {
      if (this.connection) {
        this.connection.close();
      }
    },
    setPacket: function setPacket(packet) {
      if (this.from === '0') {
        this.devicePackets.unshift(packet);
      }
    },
    getDeviceTypeData: function getDeviceTypeData() {
      var data = "".concat(this.$i18n_t('NiotaClassic.Devices.type'), ":");

      if (get(this.deviceData, 'deviceType.title')) {
        data += get(this.deviceData, 'deviceType.title');
      } else {
        data += '-';
      }

      if (get(this.deviceData, 'deviceType.parser.type')) {
        data += "(".concat(this.$i18n_t('NiotaClassic.Devices.parser'), ":");
        data += "".concat(get(this.deviceData, 'deviceType.parser.type'), ")");
      }

      return data;
    }
  }
};